import listenTestStandLogs from 'features/testStand/api/listenTestStandLogs';
import { useEffect, useState } from 'react';

/**
 * Real-time listener for the test_stand_logs collection.
 * Returns the most recent `maxCount` runs ordered by createdAt desc.
 */
export default function useTestStandLogs({ maxCount = 50 } = {}) {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => listenTestStandLogs(
    (nextRuns) => { setRuns(nextRuns); setLoading(false); setError(null); },
    (err) => { setError(err.message); setLoading(false); },
    { maxCount },
  ), [maxCount]);

  return { runs, loading, error };
}
